var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSkylight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11130_7437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 9.41699V13.2727L6.18931 15.9996L11.7116 13.2727V9.41699L6.18931 12.1377L0.666992 9.41699Z",
    fill: "#9BA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18938 0L1.14844 2.48925L4.86955 4.51214L6.18938 3.86189L11.7117 6.58262V2.72695L6.18938 0Z",
    fill: "#9BA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.667008 3.04297L0.666992 6.96081L7.53258 10.6734L11.2639 8.82644L0.667008 3.04297Z",
    fill: "#9BA5B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11130_7437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0446,
    height: 16,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkylight);
export default __webpack_public_path__ + "static/media/icon_skylight.25a90a26cbbcf5a728f307cb8e2cedde.svg";
export { ForwardRef as ReactComponent };